// UploadQueue 用于做微信端的语音／图片上传
//  将queued 的元素取出 
// 上传到微信服务器， 此时状态为saving
// 上传到荔枝微课服务器， 此时和其他发送消息用相同方式上传

import {Component} from 'react';
import {connect} from 'react-redux';


class UploadQueue extends Component {
    busy = false
    queue = []

    componentDidMount() {
        this.ticks = setInterval(this.checkQueue.bind(this), 300);
    }

    componentWillUnmount() {
        clearInterval(this.ticks)
    }

    checkQueue() {
        if (this.busy) {
            return;
        }
        if (this.queue.length === 0) {
            return;
        }
        const message = this.queue[0];
        if (message.type === 'image' && message.local_id) {
            this.busy = true;
            this.props.dispatch({
                type: 'ML_TOGGLE_MESSAGE',
                payload: {
                    id: message.id,
                    status: 'saving'
                }
            });
            window.wx.uploadImage({
                localId: message.local_id,
                isShowProgressTips: 0,
                complete: (res) => {
                    if (res.serverId) {
                        this.props.dispatch({
                            type: 'ML_TOGGLE_MESSAGE',
                            payload: {
                                id: message.id,
                                status: 'send',
                                server_id: res.serverId,
                                content: res.serverId,
                            }
                        });
                    } else {
                        this.props.dispatch({
                            type: 'ML_TOGGLE_MESSAGE',
                            payload: {
                                id: message.id,
                                status: 'queued'
                            }
                        });
                    }
                    this.busy = false;
                }
            });
        }
        if (message.type === 'voice' && message.local_id) {
            this.busy = true;
            this.props.dispatch({
                type: 'ML_TOGGLE_MESSAGE',
                payload: {
                    id: message.id,
                    status: 'saving'
                }
            });

            setTimeout(() => {
                // 10秒后检查是否请求微信上传语音的接口，没有则重置改语音失败
                let timer = setTimeout(() => {
                    this.props.dispatch({
                        type: 'ML_TOGGLE_MESSAGE',
                        payload: {
                            id: message.id,
                            status: 'failed'
                        }
                    });
                    this.busy = false;

                    // 检测失败语音条数，超过两条则弹窗提示
                    let dump = localStorage.getItem('lecture-unsend-' + this.props.lectureId)
                    if (dump) {
                        dump = JSON.parse(dump)
                        if (dump.length >= 2) {
                            this.props.dispatch({
                                type: 'CLASSROOM_SHOW_NOLISTEN_DIALOG',
                                payload: 'send'
                            })
                        }
                    }
                }, 10000);

                window.wx.uploadVoice({
                    localId: message.local_id,
                    isShowProgressTips: 0,
                    complete: (res) => {
                        clearTimeout(timer);
                        if (res.serverId) {
                            this.props.dispatch({
                                type: 'ML_TOGGLE_MESSAGE',
                                payload: {
                                    id: message.id,
                                    status: 'send',
                                    server_id: res.serverId,
                                    content: res.serverId,
                                }
                            });
                        } else {
                            this.props.dispatch({
                                type: 'ML_TOGGLE_MESSAGE',
                                payload: {
                                    id: message.id,
                                    status: 'queued'
                                }
                            });
                        }
                        this.busy = false;
                    }
                });
            }, 100);
        }
        this.queue = this.queue.filter(m => m.id !== message.id);
    }

    componentDidUpdate() {
        const {messages} = this.props.messageList;
        messages.map((m, i) => {
            if (m.status === 'queued' && this.queue.indexOf(m) === -1) {
                setTimeout(() => {
                    console.log('queue', m);
                    this.queue.push(m);
                }, 300);
            }
            return null;
        });
    }

    render() {
        return null;
    }
}


export default  connect((state) => ({
    messageList: state.messageList,
    lectureId: state.classroom.lecture.id
}))(UploadQueue);




// WEBPACK FOOTER //
// ./src/components/UploadQueue.js